import { FC } from "react";

import { IDataPaneProps } from "types/tab";
import { OrderPaneLoading } from "./OrderPaneLoading";
import styles from "./RawPane.module.scss";

const RawPane: FC<IDataPaneProps> = ({ order, loading }) => {
    if (loading) {
        return <OrderPaneLoading />;
    }

    return (
        <div className={styles.root}>
            <pre className={styles.pre}>{JSON.stringify(order, null, 2)}</pre>
        </div>
    );
};

export default RawPane;
